// extracted by mini-css-extract-plugin
module.exports =  {"cpAcccordionHeader":"DetailsPage_cpAcccordionHeader__n70yL","cpDetailsBuildingIcon":"DetailsPage_cpDetailsBuildingIcon__SP6PJ"};